import Vue from 'vue'
import VueRouter from 'vue-router'
import Admin from '../views/Admin.vue'
import User from '../views/User.vue'
import Login from '../views/Login.vue'
import NotFound from '../components/404.vue'

import Self from '../components/Self.vue'
import UserManage from '../components/UserManage.vue'
import AttractionManage from '../components/AttractionManage.vue'
import TrendCommentManage from '../components/TrendCommentManage.vue'
import BigScreen from '../components/BigScreen.vue'
import Trend from '../components/Trend.vue'
import TrendManage from '../components/TrendManage.vue'
import UserViewRecord from '../components/UserViewRecord.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/0',
        name: 'Admin',
        component: Admin,
        meta: {requiresAuth: true, role: 0},
        children: [
            {meta: {requiresAuth: true, role: 0,nav:true}, name: '用户管理', path: 'UserManage', component: UserManage,},
            {meta: {requiresAuth: true, role: 0,nav:true}, name: '景点管理', path: 'AttractionManage', component: AttractionManage,},
            {meta: {requiresAuth: true, role: 0,nav:true}, name: '游记管理', path: 'TrendManage', component: TrendManage,},
            {meta: {requiresAuth: true, role: 0,nav:true}, name: '游记评论管理', path: 'TrendCommentManage', component: TrendCommentManage,},
        ],
    },
    {
        path: '/2',
        name: 'User',
        component: User,
        meta: {requiresAuth: true, role: 2},
        children: [

            {meta: {requiresAuth: true, role: 2,nav:true}, name: '可视化大屏', path: 'BigScreen', component: BigScreen,},
            {meta: {requiresAuth: true, role: 2,nav:true}, name: '游记分享', path: 'Trend', component: Trend,},
            {meta: {requiresAuth: true, role: 2,nav:true}, name: '我的足迹', path: 'UserViewRecord', component: UserViewRecord,},
            {meta: {requiresAuth: true, role: 2,nav:true}, name: '个人中心', path: 'Self', component: Self,},
        ],
    },

    {
        path: '/',
        name: 'Login',
        component: Login,
    },
    {
        path: '*',
        name: '404',
        component: NotFound
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        if (Vue.prototype.$store.state.loginUser.id === undefined) {
            Vue.prototype.$message.warning('请登录')
            next('/')
        } else if (to.meta.role !== Vue.prototype.$store.state.loginUser.role) {
            Vue.prototype.$message.warning('您无权限')
            next(from.fullPath)
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
